






















































































































import { Component, Vue } from 'vue-property-decorator';
import Headerhome from '../../components/headerhome.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
library.add(faEnvelopeOpenText, faHome, faPhoneAlt, faFacebook);
@Component({
  components: { Headerhome },
})
export default class ContactPage extends Vue {}
